import React, { useState } from "react";
import copyText from "~/images/copy-text.svg";
import Button from "./Button";
const CopyText = ({ description, siteAudit = false }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(description);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = description;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      // setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };
  return (
    <div className="relative inline-block">
      <Button
        onClick={handleCopy}
        className={`!hover:shadow-sm !hover:border-gray-300 !bg-white px-4 py-2 border border-gray-200 !text-[#535353] text-[16px] flex items-center space-x-2 transition-colors ${
          siteAudit ? "!rounded-[7px]" : "rounded-xl"
        }`}
      >
        <img src={copyText} className="h-5 w-5" />
        <span className="font-medium">{copied ? "Copied!" : "Copy"}</span>
      </Button>
      {/* {copied && <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded shadow">Copied!</div>} */}
    </div>
  );
};

export default CopyText;
